export default __webpack_public_path__ + "static/media/facility_03_3.75b746cb.png";